import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import MetisMenu from 'metismenujs';
import { Router, NavigationEnd } from '@angular/router';
import { MENU, PENNYLANE_GESTION_MENU_APPLICATION } from './menu';
import { MenuItem } from './menu.model';
import { AuthenticationService } from 'src/app/core/providers/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AppContextService } from 'src/app/core/providers/context/AppContextService ';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})

/**
 * Sidebar Component
 */
export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  menu: any;
  menuItems: MenuItem[] = [];
  subscription: Subscription = new Subscription();
  applications: any[] = [];

  constructor(
    private router: Router,
    public translate: TranslateService,
    private authService: AuthenticationService<any>,
    private appContextService: AppContextService
  ) {
    this.menuItems = this.filterMenuItemsByRole(MENU); // Filtrez les éléments du menu
    translate.setDefaultLang('fr');
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit(): void {
    this.subscription.add(
      this.appContextService.context$.subscribe((context) => {
        this.updateCurrentUserAndMenuItem(context);
      })
    );
  }

  updateCurrentUserAndMenuItem(context: any): void {
    this.authService.userValue = {
      ...this.authService.currentUserValue,
      roles: context.user.roles,
    };
    this.applications = context.applications || [];
    this.menuItems = this.filterMenuItemsByRole(MENU);
    if (!this.appCodeExists(PENNYLANE_GESTION_MENU_APPLICATION)) {
      this.menuItems = this.menuItems.filter(
        (item: MenuItem) =>
          item.application !== PENNYLANE_GESTION_MENU_APPLICATION
      );
    }
    if (!this.appCodeExists('IMPOTS_GOUV')) {
      this.menuItems = this.menuItems.filter(
        (item: MenuItem) => item.application != 'IMPOTS_GOUV'
      );
    }
  }

  /**
   * Filtre les éléments du menu en fonction des rôles de l'utilisateur
   * @param items Les éléments du menu à filtrer
   */
  filterMenuItemsByRole(items: MenuItem[]): MenuItem[] {
    return items
      .filter((item) => {
        if (item.profileCode && !this.authService.hasCurrentProfileCode(item.profileCode)) {
          return false;
        }
        if (!item.roles || item.roles.length === 0) {
          return true;
        }
        return this.authService.hasAnyRole(item.roles);
      })
      .map((item) => ({
        ...item,
        subItems: item.subItems
          ? this.filterMenuItemsByRole(item.subItems)
          : undefined,
      }));
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    this.menu = new MetisMenu('#side-menu');
    this._activateMenuDropdown();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links: any = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) {
              childAnchor.classList.add('mm-active');
            }
            if (childDropdown) {
              childDropdown.classList.add('mm-active');
            }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  }

  appCodeExists(code: string): any {
    return this.applications.find((app) => app.appCode === code);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
